// extracted by mini-css-extract-plugin
export var bodySections = "_3w-8";
export var gray = "_3w-7";
export var green = "_3w-4";
export var iconContainer = "_3w-9";
export var iconWidgetContainer = "_3w-1";
export var phoneIcon = "_3w-2";
export var red = "_3w-5";
export var statusDot = "_3w-3";
export var widgetContainer = "_3w-0";
export var yellow = "_3w-6";